export const reserveABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'symbols', internalType: 'bytes32[]', type: 'bytes32[]', indexed: false },
            { name: 'weights', internalType: 'uint256[]', type: 'uint256[]', indexed: false },
        ],
        name: 'AssetAllocationSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'ratio', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'DailySpendingRatioSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'exchangeSpender', internalType: 'address', type: 'address', indexed: true }],
        name: 'ExchangeSpenderAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'exchangeSpender', internalType: 'address', type: 'address', indexed: true }],
        name: 'ExchangeSpenderRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'otherReserveAddress', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OtherReserveAddressAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'otherReserveAddress', internalType: 'address', type: 'address', indexed: true },
            { name: 'index', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'OtherReserveAddressRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'spender', internalType: 'address', type: 'address', indexed: true },
            { name: 'to', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ReserveGoldTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'spender', internalType: 'address', type: 'address', indexed: true }],
        name: 'SpenderAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'spender', internalType: 'address', type: 'address', indexed: true }],
        name: 'SpenderRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'TobinTaxReserveRatioSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'TobinTaxSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'TobinTaxStalenessThresholdSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'token', internalType: 'address', type: 'address', indexed: true }],
        name: 'TokenAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'index', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'TokenRemoved',
    },
    { payable: true, stateMutability: 'payable', type: 'fallback' },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'assetAllocationSymbols',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
        name: 'assetAllocationWeights',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'exchangeSpenderAddresses',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'frozenReserveGoldDays',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'frozenReserveGoldStartBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'frozenReserveGoldStartDay',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'isExchangeSpender',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'isOtherReserveAddress',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'isSpender',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'isToken',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'lastSpendingDay',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'otherReserveAddresses',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'spendingLimit',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'tobinTax',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'tobinTaxCache',
        outputs: [
            { name: 'numerator', internalType: 'uint128', type: 'uint128' },
            { name: 'timestamp', internalType: 'uint128', type: 'uint128' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'tobinTaxReserveRatio',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'tobinTaxStalenessThreshold',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'registryAddress', internalType: 'address', type: 'address' },
            { name: '_tobinTaxStalenessThreshold', internalType: 'uint256', type: 'uint256' },
            { name: '_spendingRatio', internalType: 'uint256', type: 'uint256' },
            { name: '_frozenGold', internalType: 'uint256', type: 'uint256' },
            { name: '_frozenDays', internalType: 'uint256', type: 'uint256' },
            { name: '_assetAllocationSymbols', internalType: 'bytes32[]', type: 'bytes32[]' },
            { name: '_assetAllocationWeights', internalType: 'uint256[]', type: 'uint256[]' },
            { name: '_tobinTax', internalType: 'uint256', type: 'uint256' },
            { name: '_tobinTaxReserveRatio', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256' }],
        name: 'setTobinTaxStalenessThreshold',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256' }],
        name: 'setTobinTax',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256' }],
        name: 'setTobinTaxReserveRatio',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'ratio', internalType: 'uint256', type: 'uint256' }],
        name: 'setDailySpendingRatio',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getDailySpendingRatio',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'frozenGold', internalType: 'uint256', type: 'uint256' },
            { name: 'frozenDays', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setFrozenGold',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'symbols', internalType: 'bytes32[]', type: 'bytes32[]' },
            { name: 'weights', internalType: 'uint256[]', type: 'uint256[]' },
        ],
        name: 'setAssetAllocations',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'addToken',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeToken',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'reserveAddress', internalType: 'address', type: 'address' }],
        name: 'addOtherReserveAddress',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'reserveAddress', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeOtherReserveAddress',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
        name: 'addSpender',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
        name: 'removeSpender',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
        name: 'addExchangeSpender',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'spender', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeExchangeSpender',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getExchangeSpenders',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'to', internalType: 'address payable', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'transferGold',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'to', internalType: 'address payable', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'transferExchangeGold',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'getOrComputeTobinTax',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getTokens',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getOtherReserveAddresses',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getAssetAllocationSymbols',
        outputs: [{ name: '', internalType: 'bytes32[]', type: 'bytes32[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getAssetAllocationWeights',
        outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getUnfrozenBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getReserveGoldBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getOtherReserveAddressesGoldBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getUnfrozenReserveGoldBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getFrozenReserveGoldBalance',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getReserveRatio',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
];
